<template>
<modal classes="xmd:w-full mx-auto overflow-auto pb-4 max-w-xsm xmd:max-w-xl bg-white" @close="$emit('close')">
  <div class="rating-rule-modal">
        <h1 class="lg:mt-8">Как рассчитывается рейтинг?</h1>
        <!-- <div class="flex rules" v-for="(rule , index) in rules" :key="index">
             <img src="@/assets/ellipse.png" alt />
             <p v-html="rule.rule"></p>
        </div> -->
        <div class="mt-10">
          <p>На позицию в рейтинге влияют количество игр, в которых поучаствовала команда, и количество раз, когда команда заняла призовое место.<br><br>Если команда заняла 1-е, 2-е или 3-е место, ее финальный балл за игру умножается на коэффициент 1.2.<br><br>Остальные команды в таблице, кроме занявших призовые места, делятся на две части. Если число команд нечетное, команда в середине списка относится к тем, кто набрал меньше баллов.<br><br>Команды из первой половины таблицы получают повышающий коэффициент 1.1. А если по итогам игры команда оказалась во второй группе с меньшим количеством баллов, то баллы за игру добавляются к рейтингу без дополнительных коэффициентов.</p>
          <p class="mt-6"><span class="text-brand-light font-bold">Объясним на примере. </span><br class="hidden xmd:block"><br class="hidden xmd:block"><span class="lg:mt-5">На игре было 20 команд. Команда «А» получила 40 баллов и заняла 2-е место. Умножаем 40 на 1.2 и получаем 48 баллов. Именно этот итог и попадет в рейтинг. Все команды с 4-го по 11-е место могут смело умножать свои баллы за игру на коэффициент 1.1. К примеру, команда «К», занявшая 7-е место с 35 баллами, заработает 38,5 балла рейтинга. У остальных 10 команд (с 12-го по 20-е место) баллы за игру прибавляются к рейтингу без дополнительных коэффициентов.</span></p>
        </div>
      </div>
      </modal>
</template>

<script>
import modal from '@/views/modals/new-base-modal.vue';

export default {
  components: {
    modal,
  },
  data() {
    return {
      // rules: [
      //   { rule: '<p>Количество игр, в которых поучаствовала команда, и количество раз,когда команда<br class="hidden xmd:block"> заняла призовое место, влияют на ее позицию в рейтинге.</p>' },
      //   { rule: '<p>За 1, 2 или 3 место команда получает повышающий коэффициент 1.2. Итоговый балл<br class="hidden xmd:block"> команды за игру умножается на 1.2, и получившееся число попадает в общую сумму<br class="hidden xmd:block"> баллов команды в рейтинге.</p>' },
      //   { rule: '<p>Первая половина команд, кроме призовых мест, получает повышающий коэффициент<br class="hidden xmd:block"> 1.1. Итоговый балл команды за игру умножается на 1.1, и получившееся число попадает в<br class="hidden lg:block"> общую сумму баллов команды в рейтинге.</p>' },
      //   { rule: '<p>Баллы остальных команд остаются без изменений и также суммируются с баллами за<br class="hidden xmd:block"> все предыдущие игры.</p>' },
      // ],
    };
  },
};
</script>

<style scoped>
 .rating-rule-modal {
  width: 100%;
  height: 100%;
  padding: 0 64px 80px 64px;
}
.rating-rule-modal h1 {
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
  color: #333333;
}
.rules {
  margin-top: 37px;
}
.rules img {
  height: 12px;
  width: 12px;
  margin-right: 12px;
}
.rules p {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #333333;
}
@media screen and (min-width: 100px) and (max-width: 1024px) {
.rating-rule-modal {
    max-height: 580px;
    padding: 0 16px 16px 16px;
  }
  .rating-rule-modal h1 {
    font-size: 18px;
    line-height: 22px;
    width: 80%;
  }
  .rating-rule-modal p {
    font-size: 12px;
    line-height: 15px;
  }
  .rating-rule-modal .rule1 {
    margin-top: 24px;
  }
}
</style>
